module.exports = __webpack_public_path__ + "img/yuanchaosheng.056ccc52.png";